import IError, { instanceOfIError } from "./IError";
import Nullable from "./utils/Nullable";

interface ICodeError{
    message: string,
    error: Nullable<IError>,
    colno: number,
    line: number,
    file: string
}

export const instanceOfICodeError = (object: any) : object is ICodeError => {
    if(typeof object.error === 'undefined' || (object.error != null && !instanceOfIError(object.error))){
        return false
    }

    return 'message' in object &&
            'colno' in object &&
            'line' in object &&
            'file' in object
}

export default ICodeError